import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const Packs = styled.div<{ rows?: number }>`
	position: relative;
	display: grid;
	width: max-content;
	gap: 4px;
	grid-template-columns: repeat(3, 100px);
	/* grid-template-rows: pcss_lin0; */
	grid-template-rows: ${({ rows = 3 }) => 'repeat(' + rows + ', 150px)'};
`;

export const Image = css`
	width: 100%;
	height: 100%;
	border-radius: var(--radius-xxs);
	cursor: pointer;
	object-fit: cover;
`;

export const SecureImage = styled.div`
	position: relative;
	overflow: hidden;
	width: 100px;
	height: 150px;
	cursor: pointer;
	img {
		overflow: hidden;
		border-radius: var(--radius-xxs);
		object-fit: cover;
		transition: opacity 0.2s;
	}
	.play {
		position: absolute;
		z-index: 2;
		margin: auto;
		inset: 0;
	}
`;

export const Lock = styled.div`
	position: absolute;
	z-index: 1000;
	right: 4px;
	bottom: 4px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 1px 6px;
	border-radius: var(--radius-m);
	background-color: rgba(46, 53, 57, 0.5);
	gap: 2px;
	& > svg {
		margin-left: -2px;
	}
`;
